import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	deleteShippingAddressThunk,
	generatePresignedUrlThunk,
	getUserPreferredLanguageThunk,
	logoutUserThunk,
	setDefaultAddressThunk,
	updateShippingAddressThunk,
	updateUserPreferredLanguageThunk,
} from './commonThunk'

export const logoutUser = createAsyncThunk('login/logoutUser', logoutUserThunk)
export const getPreferredLanguage = createAsyncThunk('login/getPreferredLanguage', getUserPreferredLanguageThunk)
export const updatePreferredLanguage = createAsyncThunk('login/logoutUser', updateUserPreferredLanguageThunk)
export const setDefaultAddress = createAsyncThunk('login/getDefaultAddress', setDefaultAddressThunk)
export const updateShippingAddress = createAsyncThunk('login/updateShippingAddress', updateShippingAddressThunk)
export const deleteShippingAddress = createAsyncThunk('login/deleteShippingAddress', deleteShippingAddressThunk)
export const generatePresignedUrl = createAsyncThunk('common/generatePresignedUrl', generatePresignedUrlThunk)

const initialState = {
	defaultAddressData: null,
	updateAddressData: [],
	deleteAddressData: null,
	presignedUrls: [],
	preferredLanguage: '',
}

const commonSlice = createSlice({
	name: 'login',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(logoutUser.fulfilled, (state, action) => {}).addCase(logoutUser.rejected, (state, action) => {})
		builder.addCase(setDefaultAddress.fulfilled, (state, action) => {
			state.defaultAddressData = action?.payload?.data
		})
		builder.addCase(updateShippingAddress.fulfilled, (state, action) => {
			state.updateAddressData = action?.payload?.data
		})
		builder.addCase(deleteShippingAddress.fulfilled, (state, action) => {
			state.deleteAddressData = action?.payload?.data
		})
		builder.addCase(generatePresignedUrl.fulfilled, (state, action) => {
			state.presignedUrls = action?.payload?.s3Link
		})
		builder.addCase(getPreferredLanguage.fulfilled, (state, action) => {
			state.preferredLanguage = action?.payload?.data?.preferredLanguage
		})
	},
})

export default commonSlice.reducer
